import { FC } from 'react';
import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import UserProfilePage from '../../../pages/Cards/UserProfilePage';
import UserProfileMobile from '../../../pages/Mobile/Cards/UserProfileMobile';

const UserProfileResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <UserProfileMobile /> : <UserProfilePage />;
};

export default UserProfileResponsive;
